import { useFormik } from 'formik';
import React from 'react';
import { VerticalChoiceFormView } from './VerticalChoiceFormView';
import { useDeposit } from 'providers';
import { VehicleType } from 'types';

const verticalChoices = [
  {
    label: 'voiture',
    value: 'auto',
  },
  {
    label: 'utilitaire',
    value: 'utilitaire',
  },
  {
    label: 'moto',
    value: 'moto',
  },
  {
    label: 'camping-car',
    value: 'camping-car',
  },
  {
    label: 'caravane',
    value: 'caravane',
  },
];

export const VerticalChoiceForm: React.FC = (): React.ReactElement => {
  const { setDepositType } = useDeposit();

  const {
    values: { verticalChoice },
    isSubmitting,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: { verticalChoice: verticalChoices[0].value },
    onSubmit: values => {
      setDepositType(values.verticalChoice.toUpperCase() as VehicleType);
    },
  });

  return (
    <VerticalChoiceFormView
      verticalChoice={verticalChoice}
      verticalChoices={verticalChoices}
      isSubmitting={isSubmitting}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
    />
  );
};
